import { Stack, styled } from '@mui/material';

export const MainCnt = styled(Stack)(() => ({
  height: 400,

  '& .imgCnt': {
    width: 80,
    height: 80,
    backgroundColor: 'rgba(236, 239, 241, 1)',
    borderRadius: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 10,
    '& svg': {
      height: 35,
      width: 35,
    },
  },

  '& .title': {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '100%',
    alignItems: 'center',
    color: 'rgba(0, 0, 0, 1)',
    letterSpacing: '0%',
    marginBottom: 0,
  },
  '& .subTitle': {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '22px',
    alignItems: 'center',
    color: 'rgba(66, 66, 66, 1)',
  },
}));
